import React from 'react';

export default () => <div className="disabled-overlay" />;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/disabled-overlay.js